window.question =
{
    failed: function (data)
    {
        Swal.fire(
        {
            title: "Chyba!",
            text: "Při odesílání formuláře došlo k chybě, zkuste to prosím později.",
            icon: "error",
        });
    },
    success: function (data)
    {
        const modalElement = document.getElementById("question-modal");

        if(!modalElement)
            return;

        const modal = bootstrap.Modal.getInstance(modalElement);

        if(modal)
            modal.hide();

        Swal.fire(
        {
            title: "Úspěch!",
            text: "Dotaz byl úspěšně odeslán.",
            icon: "success",
        });
    },
};